module.exports = __webpack_public_path__ + "static/media/active-filter-icon.db34c846.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active-filter-icon.svg
// module id = 487
// module chunks = 1